import {
  Headset, RadioTower, Cpu, Landmark, Wallet, HeartPulse, ShieldCheck, Cloud,
} from "lucide-react";
import { SEO } from "@/components/SEO";
import { Reveal } from "@/components/Reveal";
import { PageHead } from "@/components/Panel";
import CTABand from "@/components/CTABand";

const industries = [
  {
    icon: Headset,
    title: "Contact Center",
    text: "High-volume operations where agent productivity and queue economics drive the P&L.",
  },
  {
    icon: RadioTower,
    title: "Telecom",
    text: "Complex product catalogs, channel partners, and long renewal cycles.",
  },
  {
    icon: Cpu,
    title: "Technology",
    text: "Fast-moving pipelines and product-led motions that outgrow their systems.",
  },
  {
    icon: Landmark,
    title: "Financial Services",
    text: "Compliance-heavy processes where data governance is non-negotiable.",
  },
  {
    icon: Wallet,
    title: "Fintech",
    text: "Rapid scale, evolving products, and a constant tension between growth and controls.",
  },
  {
    icon: HeartPulse,
    title: "Healthcare",
    text: "Long sales cycles, multiple stakeholders, and strict data handling requirements.",
  },
  {
    icon: ShieldCheck,
    title: "Insurance",
    text: "Broker and agent networks, renewals, and multi-channel distribution.",
  },
  {
    icon: Cloud,
    title: "SaaS",
    text: "Recurring revenue, net retention, and the full ARR reporting stack.",
  },
];

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <SEO
        title="Industries We Serve — RevOps Consulting | RevGen Genius"
        description="RevOps consulting expertise across contact center, telecom, technology, financial services, fintech, healthcare, insurance, and SaaS."
        path="/industries"
      />
      <div className="mx-auto max-w-[1240px] space-y-24 px-5 sm:px-8">
        <PageHead
          testId="industries-head"
          label="Industries"
          title="Industry experience"
          intro="Revenue operations principles transfer across industries. The regulatory context, sales cycle, and data model do not. We've worked inside all eight of these."
        />

        <Reveal>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {industries.map((ind, i) => (
              <Reveal key={ind.title} delay={(i % 4) * 0.07}>
                <article
                  data-testid={`industry-card-${i}`}
                  className="card-lift h-full rounded-[28px] border-[1.5px] border-[#1F5FFF] bg-white p-8 shadow-[0_2px_12px_rgba(31,95,255,0.06)]"
                >
                  <ind.icon size={28} strokeWidth={1.8} className="text-[#1F5FFF]" aria-hidden="true" />
                  <h2 className="font-heading mt-5 text-lg font-semibold">{ind.title}</h2>
                  <p className="mt-3 text-[0.92rem] leading-relaxed text-[#5B6784]">{ind.text}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </Reveal>

        <CTABand
          title="Don't see your industry?"
          text="The operating principles hold. Let's talk about how they apply to your business."
          testId="industries-cta-book-button"
        />
      </div>
    </div>
  );
}
